const TYPE_LABEL: Record<string, string> = { in_the_money: "In the money" };

/** Display label for a signal type id (the signal_types catalog's label). */
export function signalTypeLabel(typeId: string): string {
  return TYPE_LABEL[typeId] ?? typeId;
}

/** A live signal as the show routes return it (W8 D3). */
export interface Signal {
  id: string;
  type_id: string;
  label: string;
  payload: Record<string, unknown>;
  deal_name?: string | null;
}

/** Why it fired, from the payload: "7.375% vs 6.125% today · closed 2023-06-14". */
export function signalDetail(signal: Signal): string {
  const { note_rate, market_rate, closed_on } = signal.payload as {
    note_rate?: number;
    market_rate?: number;
    closed_on?: string;
  };
  return [
    note_rate != null && market_rate != null
      ? `${note_rate}% vs ${market_rate}% today`
      : null,
    closed_on ? `closed ${closed_on}` : null,
    signal.deal_name ?? null,
  ]
    .filter(Boolean)
    .join(" · ");
}
